import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=81789f5e&scoped=true&"
import script from "./Protocol.vue?vue&type=script&lang=js&"
export * from "./Protocol.vue?vue&type=script&lang=js&"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=81789f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81789f5e",
  null
  
)

export default component.exports